<template>

<div class="col-md-6">
        <div class="devices-box mt-0" >
        <figure>
        <img src="images/icon02.png" alt="Image">
        </figure>
        <h5>Your Profile details</h5>
       <p class="profnam">Your Name </p>
     <p class="prsubnam">{{name}}</p>
       

 <p class="profnam">Your Email </p>
     <p class="prsubnam2">{{ email }} </p>


 <p class="profnam">Your Mobile </p>
     <p class="prsubnam2">{{ mobile }} </p>

     <p class="profnam">Status </p>
     <p class="prsubnam2">Active </p>
     <div> <a href="#" style="color: white;
padding: 8px 9px;
border-radius: 5px;
font-size: 12px;
background: linear-gradient(135deg, rgba(174,1,94,1) 1%,rgba(222,12,100,1) 16%,rgba(235,18,89,1) 30%,rgba(239,82,69,1) 67%,rgba(244,121,45,1) 83%,rgba(254,187,23,1) 100%);
text-decoration: none !important;
" @click="logout"> Logout</a></div>
        </div>
        <!-- end devices-box -->
      </div>
</template>

<script>
export default {
  props:['logincode','mobile','email','name'],
  methods:{
    logout(){
  localStorage.removeItem("loginCode");
  this.$router.push("/index");
},
  }
}
</script>

<style>
.prsubnam2 {
  color: #2b2b2b !important;
  margin-bottom: 5px !important;
  font-weight: 600 !important;
}
.profnam{margin-bottom: 0px;color: #949494;font-size: 14px;}
.prsubnam{color: #dd0c63 !important;
  margin-bottom: 5px !important;
  font-weight: 600 !important;}
</style>
